/* Website public revision API. Never call an authenticated editing endpoint. */
(function () {
  'use strict';
  var api = window.ARTICLE_REVISIONS = window.ARTICLE_REVISIONS || {};
  api.language = function () {
    var lang = window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang
      ? window.SEARCH_LANGUAGE.getCurrentLang() : document.documentElement.lang;
    return /^(en|ru|de|fr)$/.test(lang) ? lang : 'en';
  };
  api.text = function (key) {
    return window.LANG_TEXTS[api.language()]['rh_' + key];
  };
  api.request = async function (params, signal) {
    var controller = new AbortController();
    var abort = function () { controller.abort(); };
    if (signal) {
      if (signal.aborted) abort();
      else signal.addEventListener('abort', abort, { once: true });
    }
    var timer = setTimeout(abort, 15000);
    try {
      var response = await fetch('/api/revisions?' + new URLSearchParams(params), {
        credentials: 'same-origin', signal: controller.signal,
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('History request failed');
      var data = await response.json();
      if (!data.success) throw new Error('History request failed');
      return data;
    } finally {
      clearTimeout(timer);
      if (signal) signal.removeEventListener('abort', abort);
    }
  };
})();
